import Main from './Main'
import Lista from './components/TiposRestricao'
import Novo from './components/NovoTipoRestricao'

export default [
  {
    path: 'tipo-restricao',
    name: 'config.tipo-restricao',
    component: Main,
    redirect: { name: 'config.tipo-restricao.list' },
    children: [
      {
        path: '/',
        name: 'config.tipo-restricao.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.tipo-restricao.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.tipo-restricao.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/tipo-restricao/routes.js